export default __webpack_public_path__ + "static/media/img_payment.5294de2c.png";